import React from 'react';
import Navbar from '../components/Navbar';
import { ThemeProvider } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import theme from '../theme';
import InfiniteCanvas from './InfiniteCanvas';
import { ReactFlowProvider } from 'react-flow-renderer';
import MobileNotice from '../components/MobileNotice';
import { useAuth } from '../contexts/AuthContext';
import { notifyDashboardVisit } from '../lib/adminNotify';
import pkg from '../../package.json';

// The canvas needs a desktop-class viewport; below this we show MobileNotice.
const MIN_CANVAS_WIDTH = 1024;

function DashboardBody() {
  const tooSmall = useMediaQuery(`(max-width:${MIN_CANVAS_WIDTH - 1}px)`);

  if (tooSmall) return <MobileNotice />;

  return (
    <ReactFlowProvider>
      <div style={{ padding: '10px' }}>
        <div>
          <InfiniteCanvas />
        </div>
      </div>
    </ReactFlowProvider>
  );
}

function Dashboard() {
  const { currentUser, role } = useAuth();
  const pingedRef = React.useRef(false);

  React.useEffect(() => {
    // One ping per mount; skip admins here too (backend re-checks and
    // throttles). Wait for role to load so we don't ping before we know.
    if (pingedRef.current || !currentUser || role == null || role === 'Admin') return;
    pingedRef.current = true;
    notifyDashboardVisit();
  }, [currentUser, role]);

  return (
    <ThemeProvider theme={theme}>
      <Navbar />
      <DashboardBody />
      <div className="footer_small">
        <span>Version: {pkg.version}</span>
      </div>
    </ThemeProvider>
  );
}

export default Dashboard;
